import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import ImageUpload from '../../../components/common/ImageUpload';

import { CategoryType } from '../../../models/type.model';
import { useNavigate, useParams } from 'react-router-dom';
import SelectDropdown from '../../../components/common/SelectDropdown';
import statusModel from '../../../models/status.model';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import methodModel from '../../../methods/methods';
import Layout from '../../../components/global/layout';
import environment from '../../../environment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { IoMdClose } from 'react-icons/io';
import { IoDocumentAttach } from 'react-icons/io5';
const AddEditCourse = () => {
  const [images, setImages] = useState({ image: '', banner: '', icon: '' });
  const defaultvalue = CategoryType;
  const { id, type } = useParams();
  const [form, setform] = useState({
    title: '',
    sub_title: '',
    document: [],
    category_id: '',
  });
  const [categories, setCategories] = useState([]);
  const [tab, setTab] = useState('info');
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [Types, setTypes] = useState();
  const user = useSelector((state) => state.user);
  const formValidation = [
    { key: 'title', required: true },
    // { key: 'description', required: true },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (tab == 'seo' && invalid) {
      toast.error('Please fill Required Fields');
    }
    if (!form?.category_id || !form?.title || !form?.image) {
      return;
    }

    if (invalid) return;
    let method = 'post';
    let url = 'course';
    let value = {
        image: form?.image,
      title: form?.title,
      description: form?.description,
      category_id: form?.category_id,
      document: form?.document,
    };
    if (id) {
      method = 'put';
      url = 'course';
      value.id = JSON.parse(id);
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history('/courses');
      }
      loader(false);
    });
  };

  const imageResult = (e, key) => {
    if(key){
      images[key] = e.value;
    }
      setImages(e?.value);
    setform({ ...form, image: e?.value });
  };

  const getCategory = (t = type) => {
    ApiClient.get('CommonCategory/all', {
      page: 1,
      count: 100,
      type: 'course',
      status: 'active',
    }).then((res) => {
      if (res.success) {
        setCategories(res.data);
      }
    });
  };

  const CategoryChange = (e) => {
    let ext = categories.find((itm) => itm.id == e);
    let value = null;
    if (ext && ext.parentCategory) value = ext.parentCategory._id;
    return value;
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('course', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setform({
            ...form,
            title: res?.data?.title,
            id: res?.data?.id,
            description: res?.data?.description,
            category_id: res?.data?.category_id?.id,
            document: res?.data?.document == null ? [] : res?.data?.document,
            image:res?.data?.image
          });
        }
        loader(false);
      });
    }
    getCategory();
  }, [id]);

  const getTypes = () => {
    ApiClient.get(`api/categorytype/listing`, { status: 'active' }).then(
      (res) => {
        if (res.success) {
          setTypes(res.data);
        }
      }
    );
  };

  const UploadFile = async (e, i) => {
    if (e?.target?.length < 1) {
      return false;
    }
    loader(true);
    let file = e.target.files[0];
    let data = new FormData();
    data.append('file', file);

    let upload = await axios(
      'http://195.35.8.196:6081/upload/document/multiple',
      {
        method: 'POST',
        data: data,
        Headers: {
          Auhtorization: `Bearer${localStorage.getItem('CRA_auth_token')}`,
        },
      }
    );
    if (upload?.data?.success) {
      setform({
        ...form,
        document: upload?.data?.data?.imagePath,
      });
    }
    loader(false);
  };

  const RemoveImage = (i, name) => {
    if (!itm) {
    }
    let fltr = form?.document?.filter((itm) => itm != name);
    setform({ ...form, document: fltr });
  };

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Course
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Course
                </p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              {tab == 'info' ? (
                <>
                  <div className="col-span-12 md:col-span-6">
                    <label>
                      Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.title}
                      onChange={(e) =>
                        setform({ ...form, title: e.target.value })
                      }
                      required
                    />
                  </div>
                  {!type ? (
                    <div className="col-span-12 md:col-span-6">
                      <label>
                        Category<span className="star">*</span>
                      </label>
                      <div className="custom_dropdown">
                        <SelectDropdown
                          id="statusDropdown"
                          displayValue="name"
                          placeholder="Select Type"
                          intialValue={form?.category_id}
                          theme="search"
                          required
                          result={(e) => {
                            setform({
                              ...form,
                              category_id: e?.value,
                            });
                            // getCategory(e.value);
                          }}
                          options={categories}
                        />
                        {submitted && !form?.category_id ? (
                          <div className="text-danger">
                            Category is Required
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="col-span-12 md:col-span-6">
                    <label>
                      Image<span className="star">*</span>
                    </label><br></br>
                    <ImageUpload model={'course'} required={submitted && !form?.image} multiple={false} value={form?.image} result={imageResult}/>
                  </div>


                  <div className="col-span-12 md:col-span-12 mb-3">
                    <label>Description</label>
                    {/* <textarea
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg  flex items-center gap-2 overflow-hidden px-2"
                      value={form?.description}
                      cols={12}
                      rows={6}
                      onChange={(e) =>
                        setform({ ...form, description: e.target.value })
                      }
                    /> */}
                    <ReactQuill
                      theme="snow"
                      value={form?.description}
                      onChange={(e) => {
                        setform(prev => ({ ...prev, description: e }));
                      }}
                    />
                  </div>
                  {/* <div className="col-span-12 md:col-span-12 mt-3">
                    <label className="lablefontcls">Document</label>
                    <br></br>
                    {form?.document &&
                      form?.document?.map((itm, i) => {
                        return (
                          <>
                            {form?.document[0] ? (
                              <>
                                <IoDocumentAttach size={100} />
                                <IoMdClose
                                  className="pointer"
                                  onClick={() => {
                                    setform({ ...form, document: [] });
                                  }}
                                />
                              </>
                            ) : null}

                            <img src="" alt="" />
                            {form?.document[0] ? null : (
                              <>
                                <button
                                  type="button"
                                  onClick={() => {
                                    document
                                      .getElementById('PDFFileUploader')
                                      .click();
                                  }}
                                  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                                >
                                  {' '}
                                  Upload File
                                </button>
                                <IoMdClose
                                  className="pointer"
                                  onClick={() => {
                                    RemoveImage(i, itm);
                                  }}
                                />
                              </>
                            )}

                            <input
                              id={`PDFFileUploader`}
                              className="hidden"
                              type="file"
                              accept=".pdf"
                              onChange={(e) => {
                                UploadFile(e, i);
                              }}
                            />
                          </>
                        );
                      })}

                    <button
                      onClick={() => {
                        setform({ ...form, document: [...form.document, ''] });
                      }}
                      type="button"
                      className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                    >
                      Add More
                    </button>
                  </div> */}
                  {/* <div className="col-span-12 md:col-span-12 mb-3">
                    <label>Description</label>
                    <textarea
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg  flex items-center gap-2 overflow-hidden px-2"
                      value={form?.description}
                      cols={12}
                      rows={6}
                      onChange={(e) =>
                        setform({ ...form, description: e.target.value })
                      }
                    />
                  </div> */}
                  {/* <div className="col-span-12 md:col-span-6">
                    <label>Parent Category</label>
                    <div className="custom_dropdown">
                      <SelectDropdown
                        id="statusDropdown"
                        displayValue="name"
                        placeholder="Set as Parent"
                        intialValue={form.parentCategory}
                        result={(e) => {
                          setform({ ...form, parentCategory: e.value });
                        }}
                        options={categories}
                        theme="search"
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-span-12 md:col-span-6">
                    <label>
                      Status<span className="star">*</span>
                    </label>
                    <div className="custom_dropdown">
                      <SelectDropdown
                        id="statusDropdown"
                        displayValue="name"
                        placeholder="Select Status"
                        intialValue={form.status}
                        result={(e) => {
                          setform({ ...form, status: e.value });
                        }}
                        options={statusModel.list}
                      />
                      {submitted && !form.status ? (
                        <div className="text-danger">Status is Required</div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div> */}

                  <div className="col-span-12 md:col-span-12 mt-3">
                    <label className="lablefontcls">Document</label>
                    <br></br>
                    {form?.document[0] ? (
                      <>
                        <IoDocumentAttach size={100} />
                        <IoMdClose
                          className="pointer"
                          onClick={() => {
                            setform({ ...form, document: [] });
                          }}
                        />
                      </>
                    ) : null}

                    <img src="" alt="" />
                    {form?.document[0] ? null : (
                      <button
                        type="button"
                        onClick={() => {
                          document.getElementById('PDFFileUploader').click();
                        }}
                        className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                      >
                        {' '}
                        Upload File
                      </button>
                    )}
                    <input
                      id="PDFFileUploader"
                      className="hidden"
                      type="file"
                      accept=".pdf"
                      onChange={UploadFile}
                    />
                  </div>

                  {/* <div className="col-span-12 md:col-span-6">
                    <label className="lablefontcls">Study Material</label>
                    <br></br>
                    <ImageUpload
                      model="users"
                      label={'Upload Document'}
                      result={(e) => imageResult(e, 'image')}
                      value={images.image || form.image}
                      multiple={true}
                    />
                  </div> */}
                </>
              ) : (
                <>
                  <div className="col-span-12 md:col-span-12">
                    <label>URL Key</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.urlKey}
                      onChange={(e) =>
                        setform({ ...form, urlKey: e.target.value })
                      }
                    />
                    <div className="small">Leave empty to auto generate</div>
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaTitle}
                      onChange={(e) =>
                        setform({ ...form, metaTitle: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Description<span className="star">*</span>
                    </label>
                    <textarea
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaDescription}
                      onChange={(e) =>
                        setform({ ...form, metaDescription: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Keywords<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.keywords}
                      onChange={(e) =>
                        setform({ ...form, keywords: e.target.value })
                      }
                      required
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditCourse;
